import { error } from "./Log"

const HeapAnalytics = {
  trackPurchase({ order, lineItems }) {
    const refinedLineItems = lineItems.map((lineItem) => ({
      product_id: lineItem.productId,
      name: lineItem.name,
      category: lineItem.categories?.join(', ') || '-',
      type: lineItem.type,
      variant: lineItem.variantId,
      sku: lineItem.sku,
      price: lineItem.listPrice,
      quantity: lineItem.quantity,
      discount: lineItem.discountAmount,
      discount_code: lineItem.discounts.join(', ') || '-',
      gross_price: lineItem.listPrice * lineItem.quantity,
      net_price: lineItem.listPrice * lineItem.quantity - lineItem.discountAmount,
      currency: 'USD',
    }))

    try {
      const summarizedPaymentEvent = {
        email: order.billingAddress?.email,
        order_id: order.orderId,
        lineItems: refinedLineItems,
        totalPrice: refinedLineItems?.map(item=>item.price)?.reduce((prev, curr)=>prev+curr, 0),
        totalNetPrice: refinedLineItems?.map(item=>item.net_price)?.reduce((prev, curr)=>prev+curr, 0),
        totalGrossPrice: refinedLineItems?.map(item=>item.gross_price)?.reduce((prev, curr)=>prev+curr, 0)
      }

      window.heap.track('Payment', summarizedPaymentEvent)
    } catch (e) {
      error('e', e)
    }
  },
  trackOrder({ order }) {
    const event = {
      email: order.billingAddress.email,
      order_id: order.orderId,
      subtotal: order.subtotal,
      total: order.grandTotal,
      shipping: order.shippingCostTotal,
      discount: order.totalDiscount,
      discount_code: order.coupons?.map(coupon => coupon.code)?.join(', ') || '-',
    }

    try {
      window.heap.track('Order', event)
    } catch (e) {
      error('e', e)
    }
  },

  identify({
    customerId,
    customerEmail,
    visitorType,
    customerOrderCount,
    pageType,
  }) {
    try {
      window.heap.identify(customerId)
      window.heap.addUserProperties({
        customerEmail,
        visitorType,
        customerOrderCount,
        pageType,
      })
    } catch (e) {
      error('e', e)
    }
  },
}

export default HeapAnalytics
